import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/base/SectionHeading';
import type { Article } from '@/types/content';

interface RankingSectionProps {
  picks: Article[];
  hot: Article[];
}

export default function RankingSection({ picks, hot }: RankingSectionProps) {
  return (
    <section aria-labelledby="home-ranking">
      <SectionHeading
        eyebrow="Editor & Readers"
        title="编辑推荐与读者热榜"
        description="左边是编辑部认为材料最扎实的几篇，右边是过去两周读者打开次数最多的档案。"
      />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-2 lg:grid-cols-2">
          {picks.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
        <div className="rounded-lg border border-background-300/70 bg-background-200/60 p-5">
          <h3 className="flex items-center gap-2 border-b border-background-300/70 pb-3 font-heading text-base font-bold text-foreground-950">
            <span className="flex h-4 w-4 items-center justify-center text-accent-600">
              <i className="ri-fire-line" />
            </span>
            读者热榜
          </h3>
          <div className="mt-2 divide-y divide-background-300/70">
            {hot.map((article, index) => (
              <ArticleCard key={article.slug} article={article} variant="ranked" rank={index + 1} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}